loginAsRun.$inject = ['$window', '$sessionStorage', 'Session'];

export default function loginAsRun($window, $sessionStorage, Session) {
    if ($window.rnSession.spectator) {
        Session.setSpectator($window.rnSession.spectator);
    }
}
